<template>
    <Image
        :alt="alt ?? data.alt"
        :fit="fit"
        :loading="isEager ? 'eager' : 'lazy'"
        :sources
        :src="data.size.url"
    />
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type {
    ImageCoverFragment,
    ImageLargeFragment,
    ImageMediumFragment,
} from '@/graphql/api'

import Image, { type ImageProps } from '@/components/Image.vue'

const props = defineProps<{
    data: ImageLargeFragment | ImageMediumFragment | ImageCoverFragment
    alt?: string
    fit?: 'contain' | 'cover' | undefined
    isEager?: boolean
}>()

const sources = computed((): ImageProps['sources'] => {
    return props.data.size.sources.map((source, i) => {
        const srcset: string[] = [`${source.url} 1x`]

        const size_x2 = props.data.size_x2.sources[i]
        if (size_x2) {
            srcset.push(`${size_x2.url} 2x`)
        }

        return {
            mimeType: source.mimeType,
            srcset,
        }
    })
})
</script>
